<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('import.configurations') }}</span></li>
				</ul>
			</div>
		</div>

		<div class="toolbar">
			<button id="table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="table_search collapse">
					<div class="row">
						<h4 class="uk-text-normal search_title">
							{{ $t('filter') }}
							<div class="uk-float-right section_settings">
								<span class="uk-collapse" uk-icon="icon: chevron-up; ratio: .8"></span>
							</div>
						</h4>
					</div>
					<div class="row">
						<div id="search-controls">
							<div id="types" class="multicheckbox-filter col-sm-2 colspan-1">
								<label>{{ $t('migration.management.type') }}</label><br>
								<div tabindex="0" class="attribute-editor mcb-drop-down-wrapper">
									<div class="mcb-drop-down-btn fa fa-list-ul"></div>
									<div class="value-list"></div>
								</div>
								<div class="mcb-item-list" style="display: none;">
									<div class="mcb-controls">
										<div class="mcb-clear blank" tabindex="0"></div>
										<input class="mcb-search " type="text" tabindex="-1">
										<button class="button_reset fa fa-times" tabindex="-1"></button>
									</div>
									<ul class="checkbox-list mcb-filter-list">
										<li v-for="(type, key) in types" :key="key"><input
											class="attribute-editor bg-editor" type="checkbox" :value="type">{{ type }}
										</li>
									</ul>
									<ul class="checkbox-sublist mcb-filter-list"></ul>
								</div>
							</div>
							<div id="debug" class="col-sm-2 colspan-1">
								<label>{{ $t('migration.management.debug') }}</label>
								<br>
								<select class="select attribute-editor">
									<option value="any">{{ $t('any') }}</option>
									<option value="true">{{ $t('true') }}</option>
									<option value="false">{{ $t('false') }}</option>
								</select>
							</div>
							<div v-if="global" id="global" class="col-sm-2 colspan-1">
								<label>{{ $t('migration.management.global') }}</label>
								<br>
								<select class="select attribute-editor">
									<option value="any">{{ $t('any') }}</option>
									<option value="true">{{ $t('true') }}</option>
									<option value="false">{{ $t('false') }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="search_button">
							<button id="search" class="uk-button uk-button-primary uk-button-small">{{ $t('search') }}
							</button>
							<button id="search-clear" class="uk-button uk-button-default uk-button-small">{{
								$t('clear.filters') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div class="row table-area-row control-container">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a>{{ $t('edit.configuration') }}</a></li>
				<li><a>{{ $t('delete') }}</a></li>
			</ul>
		</div>

		<div class="form">
			<div class="form-body">
				<div id="tag-manager" class="modal fade modal-window control-container" tabindex="-1" role="dialog"
					 aria-labelledby="migration-manager" aria-hidden="true">
					<div class="modal-dialog">
						<div class="modal-content">

							<div class="row control-container">
								<div class="col-sm-12">
									<p id="tag-manager-name" class="form-group-name"></p>
									<div class="row">
										<div class="new-migration_name">
											<label id="tag-name_label" for="tag-name">{{ $t('tag.name') }}</label>
											<br>
											<input id="tag-name" type="text" class="textInput attribute-editor">
											<button class="button_reset fa fa-times"></button>
										</div>
									</div>

									<div class="row">
										<button id="tag-save"
												class="button button-positive button_auto-width attribute-editor">{{
											$t('save') }}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade modal-window control-container" tabindex="-1" role="dialog"
			 aria-labelledby="migration-manager" aria-hidden="true" id="edit-global-migration-error">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="row">
						<div class="alert alert-danger display-none">
							{{ $t('configuration.global.not-admin-edit.error') }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade modal-window control-container" tabindex="-1" role="dialog"
			 aria-labelledby="migration-manager" aria-hidden="true" id="delete-global-migration-error">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="row">
						<div class="alert alert-danger display-none">
							{{ $t('configuration.global.not-admin-delete.error') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { NewImportConfigManager } from '@/core/migration/NewImportConfigManager'
import { EditImportConfigManager } from '@/core/migration/EditImportConfigManager'
import { getResourceFileLink } from '@/core/migration/supportMigrationFunctions'
import { resizeTableHeight, Table } from '@/core/support_gui_components/table/table'
import { getLocalizedMessage, removeTabindex, showMessageAlert } from '@/core/shared'
import { bindResetButton } from '@/core/input_controls/button/button'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'

export default {
	name: 'ImportMigrationManagement',
	metaInfo () {
		return {
			title: this.$t('import.configurations')
		}
	},
	data () {
		return {
			types: ['EXCEL', 'CSV', 'XML', 'PDF', 'ZIP_ATTACHMENT']
		}
	},
	props: [
		'global'
	],
	mounted () {
		let vm = this
		let companyId = this.global ? null : this.$store.getters.getProfile.companyId
		let global = this.global ? this.global : null

		let types = vm.types

		window.newItemManager = new NewImportConfigManager(companyId)
		newItemManager.setImportTypes(types)

		window.editItemManager = new EditImportConfigManager(companyId)

		window.itemStructure = {
			'phase': { 'type': 'S' },
			'types': { 'type': 'L' },
			'debug': { 'type': 'B' },
			'global': { 'type': 'B' }
		}

		let columns = [
			{
				'checkbox': true
			},
			{
				'title': 'ID',
				'columnName': 'id',
				'attribute': 'id'
			},
			{
				'title': 'name',
				'columnName': 'name',
				'attribute': 'name'
			},
			{
				'title': 'type',
				'columnName': 'type',
				'attribute': 'type'
			},
			{
				'title': 'XSLT',
				'columnName': 'xslt_link',
				'attribute': 'parameters_xslt'
			},
			{
				'title': 'debug.mode',
				'columnName': 'debug_mode',
				'attribute': 'parameters_debug'
			},
		]

		if (!global) {
			columns.push({
				'title': 'global.migration',
				'columnName': 'global_value',
				'attribute': 'company_id'
			})
		}

		let tableId = global ? 'globalImportMigrationsTable' : 'importMigrationsTable'
		this.$store.dispatch(USER_CONFIG, tableId + '.tableState')
			.then((config) => {
				window.table = new Table(tableId,
					{
						selector: '#table',
						columns: columns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						cellsSelectionsSupport: true,
						itemsSelectionsSupport: true,
						restoringSupport: true,
						filterPreProcessor: function (filter) {
							var newFilter = {}
							for (var fieldName in filter) {
								newFilter[fieldName] = filter[fieldName]['val']
							}
							return newFilter
						}
					},
					{
						contextMenu: {
							1: function (item) {
								if (item.companyId == null && !global) {
									showMessageAlert(vm.$t('configuration.global.not-admin-edit.error'), 'warning')
									return
								}

								editItemManager.setEditableMigration(item)
								editItemManager.initEditMigrationForm(table)
								editItemManager.renderEditMigrationParameters()
							},
							2: function (item) {
								if (item.companyId == null && !global) {
									showMessageAlert(vm.$t('configuration.global.not-admin-delete.error'), 'warning')
									return
								}

								editItemManager.deleteMigration(item, table)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								table.callbacks.contextMenu['1'](item)
							}
						}
					},
					function (data) {
						_.each(data, function (value) {
							if (value.parameters !== undefined) {
								if (value['parameters'].xslt) {
									var link = getResourceFileLink(value['parameters'].xslt[0], global)
									value['xslt_link'] = "<a onclick=\"downloadManager('" + link.url + "')\">" + link.name + "</a>"
								}
							}

							value.debug_mode = getLocalizedMessage(value.parameters.debug)
							value.global_value = getLocalizedMessage(value.companyId == null)
						})
					})
				table.setSavedState(config)
				var prefix = window.urlContext + (global ? 'global' : 'company/' + companyId)
				table.setDataIDsUrl(prefix + '/imports/ids')
				table.setDataSortUrl(prefix + '/imports/sort')
				table.setDataUrl(prefix + '/imports/load')
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
				initFilterForm(itemStructure, table)
				enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })
				enableHotkeyForSearch(itemStructure, table)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG ' + tableId, error)
			})

		$('#table_toolbar_add').click(function () {
			newItemManager.initNewMigrationForm(table)
		})

		$(window).resize(function () {
			resizeTableHeight()
			table.frozenTableElements.setFrozenHeaderCellsWidth()
			table.frozenTableElements.setFrozenColumnCellsHeight()
		})
	}
}
</script>

<style scoped>

</style>
